module.exports = "/_next/static/images/init_image-94d345dd30a1e239809161dcf66b1d5c.svg";